import { ProductOptionConfig } from "@shared_packages/toolkit/types";
import { type ColumnDef } from "@tanstack/react-table";
import React, { type FC } from "react";
import { useNavigate } from "react-router-dom";
import {
  DateTableCell,
  PaginationControl,
  ReactTableComponent,
  Status,
} from "../../../../components/ui-kit";
import { AppRoutes } from "../../../../constants/routes";
import { ProductVariantApiType } from "../../../../util/types";

// const Switch = styled(SwitchButton)`
//   margin-left: 25px;
// `;

interface ProductsTableProps {
  data: ProductVariantApiType[];
  pagination: PaginationControl;
}

const ProductsTable: FC<ProductsTableProps> = ({ data, pagination }) => {
  const navigate = useNavigate();
  const onRowClick = (row: ProductVariantApiType) => {
    navigate(`${AppRoutes.Private.Inventory.PRODUCT_DETAILS + row._id}`);
  };
  // const { refreshproducts } = useproductsContext();

  const columns = React.useMemo<Array<ColumnDef<ProductVariantApiType, any>>>(
    () => [
      {
        header: "Name",
        meta: { mobileTitle: true },
        accessorKey: "name",
        enableSorting: false,
        cell: ({ row }) => {
          return (
            <>
              <span>{row.original.parentProduct?.name}</span>
              <p style={{ margin: 0 }}>
                {row.original?.productOptionConfig
                  .map((option: ProductOptionConfig) => option.optionValue)
                  .join(" /")}
              </p>
            </>
          );
        },
      },
      {
        header: "SKU",
        accessorKey: "sku",
        enableSorting: false,
      },

      {
        header: "Stock",
        accessorKey: "stock",
        enableSorting: false,
        cell: ({ row }) => row.original?.inventoryInfo?.qty,
      },

      {
        header: "Status",
        accessorKey: "status",
        enableSorting: false,
        cell: ({ row }) => (
          <Status status={row.original?.parentProduct?.status} />
        ),
      },

      {
        header: "Published date",
        accessorKey: "publishedDate",
        enableSorting: false,
        cell: ({ row: { original } }) => (
          <DateTableCell date={original?.parentProduct?.publishedDate} />
        ),
      },
    ],
    []
  );

  return (
    <>
      <ReactTableComponent
        columns={columns}
        data={data}
        onRowClick={onRowClick}
        withPagination={pagination}
        withSorting
      />
    </>
  );
};

export default ProductsTable;
